<template>
  <div>
    <mdb-row>
      <mdb-col col="12">
        <mdb-input
          :label="$t('address_name')"
          type="text"
          v-model="localAddress.name"
        />
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col col="6">
        <mdb-input
        :label="$t('address')"
        type="text"
        v-model="localAddress.addr1"
        />
      </mdb-col>
      <mdb-col col="2">
        <mdb-input
          :label="$t('address_postalcode')"
          type="text"
          v-model="localAddress.zipcode"
        />
      </mdb-col>
      <mdb-col col="4">
        <mdb-input
          :label="$t('address_city')"
          type="text"
          v-model="localAddress.town"
        />
      </mdb-col>
      <mdb-col>
        <mdb-input
          :label="$t('address_telephone')"
          type="text"
          v-model="localAddress.tel"
        />
      </mdb-col>
      <mdb-col col="5">
        <mdb-input
          :label="$t('address_email')"
          type="text"
          v-model="localAddress.email"
        />
      </mdb-col>
      <mdb-col>
        <mdb-input
          :label="$t('address_web')"
          type="text"
          v-model="localAddress.url"
        />
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbRow, mdbCol, mdbInput } from "mdbvue";
export default {
  name: "Address",
  components: { mdbRow, mdbCol, mdbInput,},
  props: {
    address: Object
  },
  data() {
    return {
      localAddress: this.address
    };
  },
  methods: {},
  watch: {
    address: function(newVal, oldVal) {
      this.localAddress = newVal;
      console.log(oldVal);
    }
  }
};
</script>

<style></style>
